import { handleActions } from 'redux-actions'
import { Immutable as ImmutableGenericsType } from 'seamless-immutable'

import { SendSmsInterface } from '../../../types/form'
import { initialState, ClientState } from './model'
import { Payload } from '../../../types'
import { prepareActions } from '../../../utils'

const actionsNames = [
  'finishBranch',
  'finishOnline',
  'identitySendSms',
  'prepareCacheAuth',
  'requestSmsCode',
  'resendCacheSmsCode',
  'saveAddresses',
  'saveClientAdditionalInfo',
  'saveClientDataToStore',
  'saveClientDetails',
  'saveClientInfo',
  'saveFetchedDataFromUrl',
  'saveFinanceEmployer',
  'saveFinanceExpenses',
  'saveFinanceIncome',
  'saveFinanceProfession',
  'saveIdentityStatusToStore',
  'saveLoanPreConfiguratorToStore',
  'sendSmsCode',
  'startIdentityStatus',
  'verifyCacheSmsCode',
]

interface Actions {
  finishBranch: (payload: Function) => void
  finishOnline: () => void
  identitySendSms: (payload: SendSmsInterface) => void
  prepareCacheAuth: any
  resendCacheSmsCode: any
  saveAddresses: any
  saveClientAdditionalInfo: any
  saveClientDataToStore: any
  saveClientDetails: any
  saveClientInfo: any
  saveFetchedDataFromUrl: any
  saveFinanceEmployer: any
  saveFinanceExpenses: any
  saveFinanceIncome: any
  saveFinanceProfession: any
  saveIdentityStatusToStore: any
  saveLoanPreConfiguratorToStore: any
  startIdentityStatus: any
  verifyCacheSmsCode: any
}

export const actions: Actions = prepareActions(actionsNames, 'client') as Actions

type State = ImmutableGenericsType<ClientState>

export default handleActions<State, Payload | string>(
  {
    [actions.saveFetchedDataFromUrl]: (state, { payload }: any): State =>
      state.set('hashedCif', payload.hashedCif).set('utmParams', payload.utmParams),
    [actions.saveClientDataToStore]: (state, action): State => {
      const data: any = action.payload
      return state.merge(data)
    },
    [actions.saveIdentityStatusToStore]: (state, action): State =>
      state.set('minedIdentityStatus', action.payload),
  },
  initialState
)
